import React from "react";
import HomeGames from "../../components/HomeGames";

const GamesAll = () => {
  return <HomeGames isDetail={true} />;
};

export default GamesAll;
